import React, { Component } from "react";
import Fade from "react-reveal";
import Card from 'react-bootstrap/Card';
import { ZoomImage } from "../ZoomImage";

class Coreo extends Component {
    state = { isOpen: false };

    handleShowDialog = () => {
        this.setState({ isOpen: !this.state.isOpen });
        console.log("cliked");
    };

    render() {
        if (!this.props.data) return null;

        const img_coreo = "images/dttm/" + this.props.data.coreo.img_riquadro_iscrizioni;
        const photo_giuria_coreo = "images/" + this.props.data.dttm.photo_giuria_coreo;
        const file_regolamento = "file/regolamento_dttm_2024.pdf";
        const dj_graphic = "images/dttm/dj_graphic.png";

        return (
            <section id="info" >
                <Fade duration={1000}>
                    <div className="row">
                        < div className="align-center">
                            <h1>
                                <span style={{ color: "#fff", textShadow: "2px 2px 2px #000", fontFamily: 'font-italic-dttm' }}>INFO</span>
                            </h1>
                        </div>
                    </div>
                 
                    <div className="row" style={{"margin-top":"20px"}}>
                        <div className="one column"></div>
                        {/* info */}
                        <div className="five columns">
                            <div className="card card-3d" style={{"border-radius":"8px", "padding":"38px 10px 38px 10px", "background": "url(../images/dttm/card_background.png)"}}>
                                <div className="align-center" >
                                    <h2 className="textBoxed dttmFontGrey textShadowBlackLight" style={{"fontSize":"23px"}}> 5 Aprile 2025</h2>
                                    <h3 className="dttmFontGrey">⏰ Pomeriggio </h3>
                                    <h2 className="dttmFontGrey textShadowBlackLight"> 1VS1 HIP HOP BATTLE</h2><br/>
                                    <h3 className="textBoxed dttmFontGrey textShadowBlackLight"style={{"fontSize":"20px"}} >Categorie </h3>
                                    <h3 className="dttmFontGrey textShadowBlackLight"> Cuccioli (Under 12)</h3>
                                    <h3 className="dttmFontGrey textShadowBlackLight"> Pischelli (Under 16) </h3>
                                    <h3 className="dttmFontGrey textShadowBlackLight"> Seri (open)</h3>
                                </div>
                            </div>
                        </div>
                        <div className="five columns nextColumnRow">
                            <div className="card card-3d" style={{"border-radius":"8px", "padding":"38px 10px 38px 10px", "background": "url(../images/dttm/card_background.png)"}}>
                                <div className="align-center" >
                                    <h2 className="textBoxed dttmFontGrey textShadowBlackLight" style={{"fontSize":"23px"}}> 6 Aprile 2025</h2>
                                    <h3 className="dttmFontGrey">⏰ Mattina</h3>
                                    <h2 className="dttmFontGrey textShadowBlackLight"> STAGE</h2>
                                    <h3 className="dttmFontGrey">3 lezioni con i giudici</h3>
                                    <hr style={{margin:"20px"}}/> 
                                    <h3 className="dttmFontGrey">⏰ Pomeriggio </h3>
                                    <h2 className="dttmFontGrey textShadowBlackLight"> CHOREOGRAPHIC CONTEST</h2><br/>
                                    <h3 className="textBoxed dttmFontGrey textShadowBlackLight"style={{"fontSize":"20px"}} >Categorie </h3>
                                    <h3 className="dttmFontGrey textShadowBlackLight"> Cuccioli (Under 12)</h3>
                                    <h3 className="dttmFontGrey textShadowBlackLight"> Pischelli (Under 16) </h3>
                                    <h3 className="dttmFontGrey textShadowBlackLight"> Seri (open)</h3>
                                </div>
                            </div>
                        </div>
                        
                        <div className="one column"></div>
                    </div>
                   {/* <div className="row">
                        <div className="four columns"></div>
                        <div className="four columns">
                            <div className="card card-3d" style={{"border-radius":"8px", "padding":"5px", "background": "url(../images/dttm/card_background.png)"}}>
                                <div className="row">
                                    <div className="twelve columns" style={{"text-align":"center"}}>
                                        <img src={dj_graphic} className="photoGuest" alt="dj_graphic" style={{ "max-width": "100%" }} /> 
                                   
                                    </div>
                                </div>
                            </div>    
                        </div> 
                        <div className="four columns"></div>
        </div> */}
                  
                   
                </Fade>
            </section >
        );
    }
}

export default Coreo;
